import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { type ToolDto, updateTool } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useUpdateTool = (): UseMutationResult<ToolDto, AxiosError, ToolDto> => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (tool) => updateTool({ path: { id: tool.id }, body: tool }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.tools() });
            showSuccessToast(t('successActionGeneric'));
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureActionGeneric') }),
    });
};
